import { useSelector } from 'react-redux';

import useMemberPermissions from '@app/hooks/useMemberPermission';
import { useCurrentUserMemberId } from '@app/hooks/workspace';
import { getNetPermission } from '@app/libs/permission/getNetPermission';
import { getHasContractLinkPermission } from '@app/store/user/authority/selectors';

export default function useContractLinkPermission({
  requesterMemberId,
}: {
  requesterMemberId: string;
}) {
  const hasAuthorityPermission = useSelector(getHasContractLinkPermission);
  const { permissionMap, isSuccess } = useMemberPermissions();

  const memberId = useCurrentUserMemberId();

  const managementPermission =
    requesterMemberId !== memberId
      ? { isPermitted: false, message: '다른 멤버의 링크서명 설정은\n변경할 수 없습니다.' }
      : getNetPermission({
          hasAuthorityPermission,
          hasRolePermission: permissionMap.MANAGE_CONTRACT_LINK,
        });

  /**
   * 링크 서명은 authority가 없으면 이용 불가입니다.
   */
  const assignDocumentPermission =
    requesterMemberId !== memberId
      ? { isPermitted: false, message: '다른 멤버의 링크서명 설정은\n변경할 수 없습니다.' }
      : getNetPermission({
          hasAuthorityPermission,
          hasRolePermission: permissionMap.ASSIGN_DOCUMENT,
        });

  return {
    isSuccess,
    managementPermission,
    assignDocumentPermission,
  };
}
